'use client';

import Tokens from '@/presentation/components/views/Tokens';

export default function TokensPage() {
  return (
    <div className="max-w-[1700px] mx-auto my-10 px-4 md:px-8">
      <Tokens />
    </div>
  );
}
